<div [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          type="text"
          formControlName="name"
          [placeholder]="documentTypePlaceholder()"
          [required]="true"
        />
      </mat-form-field2>

      <app-booking-select
        [ctrl]="form.get('inquiry')"
        [bindValue]="bindBookingObject"
        [tooltipText]="inquiryTooltip()"
        [required]="isInquiryRequired"
        i18n-placeholder
        placeholder="Assigned Booking"
        [showBlankItem]="true"
      >
      </app-booking-select>
    </div>
    <div class="col-md-6" *ngIf="!signInApp">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          type="text"
          formControlName="title"
          i18n-placeholder
          placeholder="Email Subject"
          [matTooltip]="emailSubjectTooltip()"
          [required]="true"
        />
      </mat-form-field2>
      <mat-form-field2 class="mat-block">
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMaxRows="5"
          rows="3"
          formControlName="message"
          [matTooltip]="emailMessageTooltip()"
          i18n-placeholder
          placeholder="Email Message"
        ></textarea>
      </mat-form-field2>
    </div>
  </div>

  <div *ngIf="!!fillBeforeSendingFields?.length" class="mt-5">
    <h6 i18n>Fill Before Sending</h6>
    <hr />
    <div class="row">
      <ng-container *ngFor="let item of fillFieldsArray?.controls; let index = index">
        <div class="col-sm-6 col-md-4 col-lg-3">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              type="text"
              [formControl]="item"
              [placeholder]="customFieldPlaceholder(index)"
              [required]="true"
            />
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
  </div>
</div>
